// @flow

import React from 'react'
import styled from 'styled-components'
import SMConst from 'frontend_core/dist/constants/sm-const'
import ReservationModel from 'frontend_core/dist/model/Reservation'
import { mediaMax, mediaMin } from 'frontend_core/dist/styles/media'
import {
  fontSize,
  spacing,
  zIndexes,
} from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'
import ReservationStatusBlock from 'components/molecules/ReservationStatusBlock'
import ReservationTermBlock from 'components/molecules/ReservationTermBlock'
import ReservationHostActionBlock from 'components/molecules/ReservationHostActionBlock'
import ReservationUseScheduleBlock from 'components/molecules/ReservationUseScheduleBlock'
import ReservationEventBlock from 'components/molecules/ReservationEventBlock'
import ReservationAddress from 'components/molecules/ReservationAddress'

const SectionTitle = styled.p`
  color: ${Colors.black};
  font-size: ${fontSize.medium}px;
  ${mediaMin.phone`
    font-size: ${fontSize.medium_2}px;
  `};
`
const MenuListItem = styled.li`
  &:not(:first-of-type) {
    border-top: 1px solid ${Colors.grayE};
  }
`
const ContentListItem = styled.li`
  padding: ${spacing.medium_2}px 0;

  &:not(:first-of-type) {
    border-top: 1px solid ${Colors.grayE};
  }

  &:last-of-type {
    padding: ${spacing.medium_2}px 0 0;
  }
`
const ReservationEventBlockWrapper = styled.div`
  margin-top: ${spacing.medium_2}px;
`

export type PropTypes = {
  phaseText: string,
  isTypeStay?: boolean,
  isActiveReservation?: boolean,
  reservationStatus: number,
  reservationStatusType: ?string,
  directReservation: boolean,
  onClickChangeInquiryToReservation: Function,
  onClickSelectPayment: Function,
  onClickRecreateReservation: Function,

  dayOfTerm: number | string,
  dueDate: ?string | Date,
  canBeReview: boolean,
  onClickPostReview: Function,

  hostActionStatus: string,
  refundAmount?: ?string,
  onClickChangeRequestFromUser: Function,
  onClickChangeRequestFromOwner: Function,

  onClickItinerary: Function,

  telNumber: string,
  onClickEventServiceLp: Function,
}

export default function ReservationCurrentStatusSection(props: PropTypes) {
  return (
    <div>
      <SectionTitle>
        {i18n.t('page.dashboard.inbox.currentStatus')}
      </SectionTitle>
      <ul>
        <ContentListItem>
          <ReservationStatusBlock
            phaseText={props.phaseText}
            isTypeStay={props.isTypeStay}
            isActiveReservation={props.isActiveReservation}
            reservationStatus={props.reservationStatus}
            reservationStatusType={props.reservationStatusType}
            directReservation={props.directReservation}
            onClickChangeInquiryToReservation={
              props.onClickChangeInquiryToReservation
            }
            onClickSelectPayment={props.onClickSelectPayment}
            onClickRecreateReservation={props.onClickRecreateReservation}
          />
        </ContentListItem>
        {props.dueDate && (
          <ContentListItem>
            <ReservationTermBlock
              dayOfTerm={props.dayOfTerm}
              dueDate={props.dueDate}
              canBeReview={props.canBeReview}
              onClickPostReview={props.onClickPostReview}
            />
          </ContentListItem>
        )}
        {/* 予約変更リクエスト、ホストからの予約変更リクエスト、お問い合わせ：予約変更リクエストに変更のとき表示 */}
        {[
          'hasChangeRequest',
          'hasChangeRequestFromHost',
          'hasChangeRequestInquiry',
          'hasGuestCancelRefund',
        ].includes(props.hostActionStatus) && (
          <ContentListItem>
            <ReservationHostActionBlock
              status={props.hostActionStatus}
              refundAmount={props.refundAmount}
              onClickChangeRequestFromUser={props.onClickChangeRequestFromUser}
              onClickChangeRequestFromOwner={
                props.onClickChangeRequestFromOwner
              }
              onClickSelectPayment={props.onClickSelectPayment}
            />
          </ContentListItem>
        )}
        {/* 予約完了・利用完了のとき表示 */}
        {props.reservationStatusType === 'hasCompletedReservation' && (
          <React.Fragment>
            <ContentListItem>
              <ReservationUseScheduleBlock
                onClickItinerary={props.onClickItinerary}
              />
            </ContentListItem>
            <ContentListItem>
              <ReservationAddress telNumber={props.telNumber} />
              <ReservationEventBlockWrapper>
                <ReservationEventBlock
                  onClickEventServiceLp={props.onClickEventServiceLp}
                />
              </ReservationEventBlockWrapper>
            </ContentListItem>
          </React.Fragment>
        )}
      </ul>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationCurrentStatusSection/index.jsx